import teamImage from 'marketing-website/media/images/pages/enterprise/team@2x.jpg';
import organiseImage from 'marketing-website/media/images/pages/enterprise/organise@2x.png';
import brainstormImage from 'marketing-website/media/images/pages/enterprise/brainstorm@2x.png';
import designImage from 'marketing-website/media/images/pages/enterprise/design@2x.png';
import scalableImage from 'marketing-website/media/images/pages/enterprise/scalable@2x.png';
import supportImage from 'marketing-website/media/images/pages/enterprise/support@2x.png';
import imageEditorImage from 'marketing-website/media/images/pages/enterprise/imageEditor@2x.png';
import dashboardImage from 'marketing-website/media/images/pages/enterprise/dashboard@2x.jpg';

import sharePreview from 'marketing-website/media/images/pages/enterprise/ogPreview.png';

import logoSamlImage from 'marketing-website/media/images/pages/enterprise/logoSAML@2x.png';
import logoGlobeImage from 'marketing-website/media/images/pages/enterprise/logoGlobe@2x.png';
import logoArrowImage from 'marketing-website/media/images/pages/enterprise/logoArrow@2x.png';
import logoEU from 'marketing-website/media/images/pages/enterprise/logoEU@2x.png';
import logoMap from 'marketing-website/media/images/pages/enterprise/logoMap@2x.png';
import logoLog from 'marketing-website/media/images/pages/enterprise/logoLog@2x.png';

import posterLogos from 'marketing-website/media/images/pages/enterprise/posterLogos.jpg';
import posterOrganise from 'marketing-website/media/images/pages/enterprise/posterOrganise.jpg';
import posterFeatures from 'marketing-website/media/images/pages/enterprise/posterFeatures.jpg';

const assets = {
  team: {
    alt: 'Organise your teams',
    src: teamImage,
    maxWidth: 647,
  },
  brainstorm: {
    alt: 'Previews of the Marvel UI',
    src: brainstormImage,
    maxWidth: 734,
  },
  organise: {
    alt: 'Organise your designs, prototypes and user tests in your folders',
    src: organiseImage,
    maxWidth: 660,
  },
  design: {
    alt: 'Illustration of 2 hands high fiving',
    src: designImage,
    maxWidth: 361,
  },
  scalable: {
    alt: 'Illustration of a hand ticking checkboxes',
    src: scalableImage,
    maxWidth: 361,
  },
  support: {
    alt: 'Illustration of 2 hands working on puzzle',
    src: supportImage,
    maxWidth: 361,
  },
  imageEditor: {
    alt: 'Image Editor inside Marvel',
    src: imageEditorImage,
    maxWidth: 530,
  },
  logoArrow: {
    alt: 'Upwards arrow logo',
    src: logoArrowImage,
    maxWidth: 78,
  },
  logoEU: {
    alt: 'European Union logo',
    src: logoEU,
    maxWidth: 78,
  },
  logoGlobe: {
    alt: 'Globe icon',
    src: logoGlobeImage,
    maxWidth: 78,
  },
  logoLog: {
    alt: 'Log icon',
    src: logoLog,
    maxWidth: 78,
  },
  logoMap: {
    alt: 'Map Icon',
    src: logoMap,
    maxWidth: 78,
  },
  logoSaml: {
    alt: 'SAML logo',
    src: logoSamlImage,
    maxWidth: 78,
  },
  dashboard: {
    alt: 'Previews of the Marvel Dashboard',
    src: dashboardImage,
    maxWidth: 725,
  },
  sharePreview: {
    src: sharePreview,
    maxWidth: 1200,
  },
  posterFeatures: {
    src: posterFeatures,
    maxWidth: 729,
  },
  posterLogos: {
    src: posterLogos,
    maxWidth: 642,
  },
  posterOrganise: {
    src: posterOrganise,
    maxWidth: 660,
  },
};

export default assets;



// WEBPACK FOOTER //
// ./src/configs/pages/enterprise/assets.js